module.exports = __webpack_public_path__ + "71d1aafd26ec52dd1e5e04aa1fc858fa.png";